import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import { ChatStyle } from './Chat.style';

interface IProps extends WithStyles<typeof ChatStyle> {
  send:(reaction:string) => void;
}

interface IState {
  open:boolean;
}

class ChatReactionBar extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      open: false
    };
  }

  public componentDidMount(): void {
    setTimeout(() => this.setState({open: true}), 100);
  }

  public render() {

    const {classes} = this.props;
    const open = this.state.open;
    
    return (
      <div className={classes.chatReactionBar} style={open?{}:{opacity:0, maxWidth:'10px'}}>
        {this.renderReactionOptions()}
      </div>
    );  

  }

  private renderReactionOptions() {
    const {open} = this.state;
    const buttons:JSX.Element[] = [];
    if (!open) {return buttons;}

    let i = 0;
    buttons.push(this.renderReactionButton((i++),"👍"));
    buttons.push(this.renderReactionButton((i++),"👌"));
    buttons.push(this.renderReactionButton((i++),"🙏"));
    buttons.push(this.renderReactionButton((i++),"🤩"));
    buttons.push(this.renderReactionButton((i++),"❤️"));
    buttons.push(this.renderReactionButton((i++),"😍"));
    buttons.push(this.renderReactionButton((i++),"😘"));
    buttons.push(this.renderReactionButton((i++),"🥰"));
    buttons.push(this.renderReactionButton((i++),"🎉"));
    buttons.push(this.renderReactionButton((i++),"💯"));
    buttons.push(this.renderReactionButton((i++),"🤣"));
    buttons.push(this.renderReactionButton((i++),"😅"));
    buttons.push(this.renderReactionButton((i++),"🤪"));
    buttons.push(this.renderReactionButton((i++),"😳"));
    buttons.push(this.renderReactionButton((i++),"🙄"));
    buttons.push(this.renderReactionButton((i++),"🤔"));
    buttons.push(this.renderReactionButton((i++),"😮"));
    buttons.push(this.renderReactionButton((i++),"😬"));
    buttons.push(this.renderReactionButton((i++),"😞"));
    buttons.push(this.renderReactionButton((i++),"😠"));
    buttons.push(this.renderReactionButton((i++),"😭"));
    return buttons;
  }

  private renderReactionButton(key:number, reaction:string) {
    const {classes, send} = this.props;

    return <div className={classes.chatReactionBarButton} key={("i"+key)}
      onClick={() => send(reaction)}>{reaction}</div>
  }
}


export default (withStyles(ChatStyle)(ChatReactionBar));



// WEBPACK FOOTER //
// ./src/components/chat/ChatReactionBar.tsx